import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { createBrowserHistory } from 'history'
import { SnackbarProvider } from 'notistack'
import React from 'react'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import App from './App'
import configureStore from './configureStore'
import { createStorageListener } from './storageListener'

const history = createBrowserHistory()
const store = configureStore(history)
const storageListener = createStorageListener(store, history)
window.addEventListener('storage', storageListener)

const app = (
  <SnackbarProvider maxSnack={3} variant='success'>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </ConnectedRouter>
    </Provider>
  </SnackbarProvider>

)
ReactDOM.render(app, document.getElementById('root'))
// registerServiceWorker()
